<template>
  <!-- <aside class="sidebar-left">
    <h2>推荐课程</h2>
    <CourseItem
      v-for="course in courses"
      :key="course.id"
      :course="course"
      @click="handleCourseClick"
    />
  </aside> -->
  <div class="video-list333">
    <div style="display: flex; justify-content: space-between; margin-top: 15px; margin-bottom: 15px;">
      <div><b>推荐课程</b></div>
      <div style="cursor: pointer;" @click="showVideoList"><span style="color: #5DB2AB"><b>更多</b></span></div>
    </div>
    <div
      v-for="(video, index) in videos"
      :key="index"
      class="video-item"
      @click="playVideo(video, index)"
    >
      <!-- <div class="video-thumbnail">
        <div class="play-icon">
          <svg viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      </div> -->

      <!-- <video
        ref="videoRefs"
        :data-index="index"
        :src="video.url"
        crossorigin="anonymous"
        preload="metadata"
        style="display: none"
        @loadeddata="captureThumbnail"
      ></video> -->

      <img
        v-if="video.thumbnail"
        src="@/image/video_default_cover.png"
        :alt="video.title"
        style="width: 200px"
      />
      <div v-else class="thumbnail-placeholder">加载中...</div>

      <h1 class="video-title">{{ video.title }}</h1>
      <!-- {{ video.title }} -->
    </div>
  </div>
</template>

<script>
import {
  ref,
  // onMounted,
} from "vue";
// import CourseItem from "./CourseItem.vue";
import { useRouter } from "vue-router";

export default {
  setup() {
    const router = useRouter();

    const courses = ref([
      { id: 1, title: "Vue 3 入门", description: "学习 Vue 3 的基础知识" },
      { id: 2, title: "React 进阶", description: "深入理解 React 的高级特性" },
      { id: 3, title: "Node.js 实战", description: "使用 Node.js 构建后端服务" },
      { id: 4, title: "TypeScript 精讲", description: "掌握 TypeScript 的核心概念" },
      { id: 5, title: "Vue 3 入门", description: "学习 Vue 3 的基础知识" },
      { id: 6, title: "React 进阶", description: "深入理解 React 的高级特性" },
      { id: 7, title: "Node.js 实战", description: "使用 Node.js 构建后端服务" },
      { id: 8, title: "TypeScript 精讲", description: "掌握 TypeScript 的核心概念" },
      { id: 9, title: "Vue 3 入门", description: "学习 Vue 3 的基础知识" },
      { id: 10, title: "React 进阶", description: "深入理解 React 的高级特性" },
      { id: 11, title: "Node.js 实战", description: "使用 Node.js 构建后端服务" },
      { id: 12, title: "TypeScript 精讲", description: "掌握 TypeScript 的核心概念" },
      { id: 13, title: "Vue 3 入门", description: "学习 Vue 3 的基础知识" },
      { id: 14, title: "React 进阶", description: "深入理解 React 的高级特性" },
      { id: 15, title: "Node.js 实战", description: "使用 Node.js 构建后端服务" },
      { id: 16, title: "TypeScript 精讲", description: "掌握 TypeScript 的核心概念" },
    ]);

    const videos = ref([
      {
        id: 1,
        title: "基站指示灯效果-未联网",
        thumbnail:
          "https://pica.zhimg.com/80/v2-ae2100994719231314853ad3a62a3a23_720w.webp?source=2c26e567",
        url:
          "https://v22api.hello-world.cool/upload/2025/03/19/20250319215241-基站指示灯效果-未联网.mp4",
      },
      {
        id: 2,
        title: "基站指示灯效果-已联网",
        thumbnail:
          "https://v22api.hello-world.cool/upload/2025/03/19/20250319223701-基站指示灯效果-已联网.mp4",
        url:
          "https://v22api.hello-world.cool/upload/2025/03/19/20250319223701-基站指示灯效果-已联网.mp4",
      },
      {
        id: 3,
        title: "基站指示灯效果-已联网",
        thumbnail:
          "https://v22api.hello-world.cool/upload/2025/03/19/20250319223745-基站指示灯效果-已联网.mp4",
        url:
          "https://v22api.hello-world.cool/upload/2025/03/19/20250319223745-基站指示灯效果-已联网.mp4",
      },
    ]);

    // function handleCourseClick (courseId) {
    //     // this.$router.push({ name: "CourseDetail", params: { id: courseId } });
    // }

    function playVideo(video, index) {
      console.log(
        "playVideo(): video=",
        video,
        "index=",
        index,
        "url=",
        video.url,
        "router=",
        router
      );

      router.push({
        name: "VideoPlayer", // 路由名称
        params: { id: video.id }, // 传递视频ID
        query: { title: video.title },
      });
    }

    function captureThumbnail(event) {
      console.log("captureThumbnail(): event=", event);

      const video = event.target;
      const index = parseInt(video.dataset.index);

      // 确保视频已加载足够的数据
      if (video.readyState < 2) return; // 0=HAVE_NOTHING, 1=HAVE_METADATA

      try {
        // 创建canvas来捕获帧
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // 设置canvas尺寸与视频相同
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        // 尝试跳到第一帧（0秒位置）
        video.currentTime = 0;

        // 由于currentTime设置是异步的，需要监听seeked事件
        const onSeeked = () => {
          // 绘制当前帧到canvas
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

          // 将canvas转为DataURL并保存到视频数据中
          videos.value[index].thumbnail = canvas.toDataURL("image/jpeg", 0.8);

          // 清理事件监听
          video.removeEventListener("seeked", onSeeked);
        };

        video.addEventListener("seeked", onSeeked);

        // 如果视频已经处于0秒位置，可能不会触发seeked事件
        if (video.currentTime === 0) {
          onSeeked();
        }
      } catch (error) {
        console.error("捕获缩略图失败:", error);
        // 使用默认缩略图或错误处理
        videos.value[index].thumbnail = "data:image/svg+xml;base64,..."; // 默认图片
      }
    }
    // captureThumbnail();

    function showVideoList() {
      console.log("showVideoList");
    }

    return {
      router,
      courses,
      videos,

      // handleCourseClick,
      playVideo,
      captureThumbnail,
      showVideoList,
    };
  },
};
</script>

<style scoped>
.sidebar-left {
  background-color: #f4f4f4;
  padding: 10px;
  width: 200px;
}

h2 {
  margin: 0 0 10px;
  font-size: 18px;
}

.video-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 5px;
  padding: 20px;
}

.video-item {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.video-item:hover {
  transform: scale(1.03);
}

.video-thumbnail {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 宽高比 */
  overflow: hidden;
  border-radius: 8px;
  background-color: #000;
}

.video-thumbnail img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
  transition: opacity 0.3s ease;
}

.video-item:hover .video-thumbnail img {
  opacity: 0.7;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.9;
  transition: all 0.3s ease;
}

.play-icon svg {
  width: 30px;
  height: 30px;
  fill: #fff;
  margin-left: 5px; /* 让三角形稍微向右偏移，看起来更居中 */
}

.video-item:hover .play-icon {
  background-color: rgba(255, 0, 0, 0.8);
  transform: translate(-50%, -50%) scale(1.1);
}

.video-title {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  text-align: center;
}
</style>
